import {
  Box,
  Button,
  Container,
  Grid,
  Link,
  Paper,
  Stack,
  Tab,
  Tabs,
  Typography,
} from '@mui/material';
import React, { useState } from 'react';

import Hidden from '@/components/ui/TzoHidden';
import AppLayout from '@/layouts/AppLayout';
import { Meta } from '@/layouts/Meta';

interface TabPanelProps {
  children?: React.ReactNode;
  index?: number;
  value?: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`faqs-content-${index}`}
      aria-labelledby={`faqs-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ px: 1, pt: 2 }}>{children}</Box>}
    </div>
  );
}

// function a11yProps(index: number) {
//   return {
//     id: `faqs-${index}`,
//     'aria-controls': `faqs-${index}`,
//   };
// }

const FAQs = () => {
  const [value, setValue] = useState(3);

  const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };
  return (
    <AppLayout
      meta={
        <Meta
          title="What are TaxZerone®'s FAQs for Form 8849?"
          description="Optimize your IRS Form 8849 e-filing process by leveraging TaxZerone's Knowledge Base and Frequently Asked Questions (FAQ)."
          keywords=""
          canonical="faqs/form-8849/"
        />
      }
    >
      <Container maxWidth="md">
        <Stack
          direction={{ xs: 'column', md: 'column' }}
          spacing={3}
          sx={{ px: { xs: 2, md: 0, textAlign: 'center' }, py: 3 }}
        >
          <Box
            component="div"
            sx={{ mt: { xs: 2, sm: 4, md: 5 }, mb: { xs: 2, sm: 4, md: 5 } }}
          >
            <Typography
              variant="h1"
              sx={{
                fontSize: { lg: 40, md: 30, sm: 24, xs: 24 },
                fontWeight: 600,
                color: '#374151',
                mb: 3,
              }}
            >
              <span className="highlight-container">
                <span className="highlight">FAQs - Form 8849</span>
              </span>{' '}
            </Typography>
            <Typography
              variant="body1"
              sx={{
                fontSize: { lg: 20, md: 18, sm: 16, xs: 16 },
                fontWeight: 400,
              }}
              id="general"
            >
              Here are some common questions you may have about Form 8849
            </Typography>
          </Box>
        </Stack>
      </Container>

      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',

          mx: '0 !important',
          width: '100% !important',
          backgroundPosition: 'center bottom',
        }}
        spacing={0}
        m={0}
      >
        <Container maxWidth="lg" sx={{ mb: 5, px: 0 }}>
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            alignItems="flex-start"
            spacing={2}
          >
            <Hidden smDown>
              <Box
                sx={{
                  maxWidth: 180,
                  position: 'sticky',
                  top: 90,
                  border: '1px solid #ccc',
                  mt: '24px !important',
                  borderRadius: 2,
                  boxShadow: '0 0 10px rgba(0,0,0,.10)',
                  backgroundColor: 'rgba(255, 255, 255, 0.85)',
                }}
              >
                <Tabs
                  value={value}
                  onChange={handleChange}
                  variant="scrollable"
                  orientation="vertical"
                  aria-label="faqs"
                  sx={{
                    textAlign: 'center',
                    justifyContent: 'center',
                    py: 1,
                  }}
                  className="faq-container"
                >
                  <Tab
                    label={
                      <React.Fragment>
                        <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}
                        >
                          <img
                            src="/assets/images/bullet-arrow.png"
                            alt="arrow"
                            style={{ width: 12, height: 12, marginRight: 4 }}
                          />
                          General
                        </Box>
                      </React.Fragment>
                    }
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                      //  color: '#ccc',
                    }}
                    href="/faqs/"
                  />
                  <Tab
                    label={
                      <React.Fragment>
                        <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}
                        >
                          <img
                            src="/assets/images/bullet-arrow.png"
                            alt="arrow"
                            style={{ width: 12, height: 12, marginRight: 4 }}
                          />
                          Form 2290
                        </Box>
                      </React.Fragment>
                    }
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                    }}
                    href="/faqs/form-2290/"
                  />
                  <Tab
                    label={
                      <React.Fragment>
                        <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'flex-start',
                          }}
                        >
                          <img
                            src="/assets/images/bullet-arrow.png"
                            alt="arrow"
                            style={{
                              width: 12,
                              height: 12,
                              marginRight: 4,
                              marginTop: 3,
                            }}
                          />
                          Form 2290 Amendments
                        </Box>
                      </React.Fragment>
                    }
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                    }}
                    href="/faqs/form-2290-amendments/"
                  />
                  <Tab
                    label={
                      <React.Fragment>
                        <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}
                        >
                          <img
                            src="/assets/images/bullet-arrow.png"
                            alt="arrow"
                            style={{ width: 12, height: 12, marginRight: 4 }}
                          />
                          Form 8849
                        </Box>
                      </React.Fragment>
                    }
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                    }}
                    href="/faqs/form-8849/"
                  />
                  <Tab
                    label={
                      <React.Fragment>
                        <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}
                        >
                          <img
                            src="/assets/images/bullet-arrow.png"
                            alt="arrow"
                            style={{ width: 12, height: 12, marginRight: 4 }}
                          />
                          Form 990
                        </Box>
                      </React.Fragment>
                    }
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                    }}
                    href="/faqs/form-990/"
                  />
                  <Tab
                    label={
                      <React.Fragment>
                        <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}
                        >
                          <img
                            src="/assets/images/bullet-arrow.png"
                            alt="arrow"
                            style={{ width: 12, height: 12, marginRight: 4 }}
                          />
                          Form 990-EZ
                        </Box>
                      </React.Fragment>
                    }
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                    }}
                    href="/faqs/form-990-ez/"
                  />
                  <Tab
                    label={
                      <React.Fragment>
                        <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}
                        >
                          <img
                            src="/assets/images/bullet-arrow.png"
                            alt="arrow"
                            style={{ width: 12, height: 12, marginRight: 4 }}
                          />
                          Form 990-N
                        </Box>
                      </React.Fragment>
                    }
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                    }}
                    href="/faqs/form-990-n/"
                  />
                  <Tab
                    label={
                      <React.Fragment>
                        <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}
                        >
                          <img
                            src="/assets/images/bullet-arrow.png"
                            alt="arrow"
                            style={{ width: 12, height: 12, marginRight: 4 }}
                          />
                          Form 941
                        </Box>
                      </React.Fragment>
                    }
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                    }}
                    href="/faqs/form-941/"
                  />
                  <Tab
                    label={
                      <React.Fragment>
                        <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}
                        >
                          <img
                            src="/assets/images/bullet-arrow.png"
                            alt="arrow"
                            style={{ width: 12, height: 12, marginRight: 4 }}
                          />
                          Form 7004
                        </Box>
                      </React.Fragment>
                    }
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                    }}
                    href="/faqs/form-7004/"
                  />
                  <Tab
                    label={
                      <React.Fragment>
                        <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}
                        >
                          <img
                            src="/assets/images/bullet-arrow.png"
                            alt="arrow"
                            style={{ width: 12, height: 12, marginRight: 4 }}
                          />
                          Form 4868
                        </Box>
                      </React.Fragment>
                    }
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                    }}
                    href="/faqs/form-4868/"
                  />
                  <Tab
                    label={
                      <React.Fragment>
                        <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}
                        >
                          <img
                            src="/assets/images/bullet-arrow.png"
                            alt="arrow"
                            style={{ width: 12, height: 12, marginRight: 4 }}
                          />
                          Form 8868
                        </Box>
                      </React.Fragment>
                    }
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                    }}
                    href="/faqs/form-8868/"
                  />
                  <Tab
                    label={
                      <React.Fragment>
                        <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}
                        >
                          <img
                            src="/assets/images/bullet-arrow.png"
                            alt="arrow"
                            style={{ width: 12, height: 12, marginRight: 4 }}
                          />
                          Form 15397
                        </Box>
                      </React.Fragment>
                    }
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                    }}
                    href="/faqs/form-15397/"
                  />
                </Tabs>
              </Box>
            </Hidden>
            <Hidden smUp>
              <Box
                sx={{
                  position: 'sticky',
                  top: 62,
                  backgroundColor: '#213e99',
                  zIndex: 1,
                  width: '100%',
                }}
              >
                <Tabs
                  value={value}
                  onChange={handleChange}
                  variant="scrollable"
                  scrollButtons
                  allowScrollButtonsMobile
                  aria-label="faqs"
                  sx={{
                    textAlign: 'center',
                    justifyContent: 'center',
                    '& .MuiSvgIcon-root': { fill: '#fff' },
                    maxWidth: 380,
                    mt: '2px',
                  }}
                  className="faq-container"
                >
                  <Tab
                    label="General"
                    // {...a11yProps(0)}
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                      color: '#ccc',
                    }}
                    href="/faqs/"
                  />
                  <Tab
                    label="Form 2290"
                    //  {...a11yProps(1)}
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                      color: '#ccc',
                    }}
                    href="/faqs/form-2290/"
                  />
                  <Tab
                    label="Form 2290 Amendments"
                    //  {...a11yProps(2)}
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                      color: '#ccc',
                    }}
                    href="/faqs/form-2290-amendments/"
                  />
                  <Tab
                    label="Form 8849"
                    //  {...a11yProps(3)}
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                      color: '#ccc',
                    }}
                    href="/faqs/form-8849/"
                  />
                  <Tab
                    label="Form 990"
                    //  {...a11yProps(4)}
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                      color: '#ccc',
                    }}
                    href="/faqs/form-990/"
                  />
                  <Tab
                    label="Form 990-N"
                    //  {...a11yProps(4)}
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                      color: '#ccc',
                    }}
                    href="/faqs/form-990-n/"
                  />
                  <Tab
                    label="Form 7004"
                    //  {...a11yProps(5)}
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                      color: '#ccc',
                    }}
                    href="/faqs/form-7004/"
                  />
                  <Tab
                    label="Form 4868"
                    //  {...a11yProps(6)}
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                      color: '#ccc',
                    }}
                    href="/faqs/form-4868/"
                  />
                  <Tab
                    label="Form 8868"
                    //  {...a11yProps(7)}
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                      color: '#ccc',
                    }}
                    href="/faqs/form-8868/"
                  />
                  <Tab
                    label="Form 15397"
                    //  {...a11yProps(8)}
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                      color: '#ccc',
                    }}
                    href="/faqs/form-15397/"
                  />
                </Tabs>
                <Box sx={{ borderBottom: 0, borderColor: 'divider' }} />
              </Box>{' '}
            </Hidden>
            <Box
              sx={{
                width: '100%',
                pt: { sm: '8px !important' },
                px: { xs: 2, sm: 0 },
              }}
              itemScope
              itemType="https://schema.org/FAQPage"
            >
              <TabPanel>
                {/* <Typography
                  variant="h2"
                  sx={{
                    fontSize: { xs: 18, sm: 20, md: 24, lg: 30 },
                    fontWeight: 600,
                  }}
                >
                  Form 8849
                </Typography> */}
                <Grid container spacing={0} rowSpacing={2} m={0} mt={0}>
                  <Grid size={12} sx={{ pt: '0 !important' }}>
                    <Paper
                      variant="outlined"
                      sx={{ p: 2 }}
                      itemScope
                      itemProp="mainEntity"
                      itemType="https://schema.org/Question"
                    >
                      <Typography
                        variant="h2"
                        sx={{
                          fontWeight: 600,
                          color: '#36324a',
                          fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                          mb: 1,
                        }}
                        itemProp="name"
                      >
                        What information is required to file Form 8849?
                      </Typography>
                      <Box
                        itemScope
                        itemProp="acceptedAnswer"
                        itemType="https://schema.org/Answer"
                      >
                        <Typography
                          variant="body1"
                          component="div"
                          itemProp="text"
                        >
                          To file{' '}
                          <Link
                            href="/excise-tax/efile-irs-form-8849-schedule-6-online/"
                            sx={{ color: '#0202ff' }}
                          >
                            Form 8849 Schedule 6
                          </Link>
                          , you’ll need the following information:
                          <ul>
                            <li>
                              Business information such as business name, EIN,
                              and address
                            </li>
                            <li>Tax-year end month</li>
                            <li>Reason for claiming credits</li>
                          </ul>
                        </Typography>
                      </Box>
                    </Paper>
                  </Grid>
                  <Grid size={12}>
                    <Paper
                      variant="outlined"
                      sx={{ p: 2 }}
                      itemScope
                      itemProp="mainEntity"
                      itemType="https://schema.org/Question"
                    >
                      <Typography
                        variant="h2"
                        sx={{
                          fontWeight: 600,
                          color: '#36324a',
                          fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                          mb: 1,
                        }}
                        itemProp="name"
                      >
                        What is a Taxpayer PIN in Form 8849?
                      </Typography>
                      <Box
                        itemScope
                        itemProp="acceptedAnswer"
                        itemType="https://schema.org/Answer"
                      >
                        <Typography
                          variant="body1"
                          component="div"
                          itemProp="text"
                        >
                          A taxpayer PIN could be any 5-digit number (except all
                          zeros), which will act as an electronic signature for
                          your Form 8849. Please make sure you remember the PIN
                          you&apos;re entering after completing the filing
                          process.
                        </Typography>
                      </Box>
                    </Paper>
                  </Grid>
                  <Grid size={12}>
                    <Paper
                      variant="outlined"
                      sx={{ p: 2 }}
                      itemScope
                      itemProp="mainEntity"
                      itemType="https://schema.org/Question"
                    >
                      <Typography
                        variant="h2"
                        sx={{
                          fontWeight: 600,
                          color: '#36324a',
                          fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                          mb: 1,
                        }}
                        itemProp="name"
                      >
                        For what reasons can I claim credits in Form 8849?
                      </Typography>
                      <Box
                        itemScope
                        itemProp="acceptedAnswer"
                        itemType="https://schema.org/Answer"
                      >
                        <Typography
                          variant="body1"
                          component="div"
                          itemProp="text"
                        >
                          You can claim credits for the following reasons in
                          <Link
                            href="/excise-tax/efile-irs-form-8849-schedule-6-online/"
                            sx={{ color: '#0202ff' }}
                          >
                            {' '}
                            Form 8849
                          </Link>
                          :
                          <ul>
                            <li>
                              If your vehicle is either sold, destroyed, or
                              stolen
                            </li>
                            <li>
                              If your taxable vehicle has traveled less than the
                              5,000-mileage limit (7,500 miles for agricultural
                              vehicles)
                            </li>
                            <li>If you have overpaid taxes</li>
                          </ul>
                        </Typography>
                      </Box>
                    </Paper>
                  </Grid>
                  <Grid size={12}>
                    <Paper
                      variant="outlined"
                      sx={{ p: 2 }}
                      itemScope
                      itemProp="mainEntity"
                      itemType="https://schema.org/Question"
                    >
                      <Typography
                        variant="h2"
                        sx={{
                          fontWeight: 600,
                          color: '#36324a',
                          fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                          mb: 1,
                        }}
                        itemProp="name"
                      >
                        What information is required if I&apos;m claiming
                        credits for sold vehicles?
                      </Typography>
                      <Box
                        itemScope
                        itemProp="acceptedAnswer"
                        itemType="https://schema.org/Answer"
                      >
                        <Typography
                          variant="body1"
                          component="div"
                          itemProp="text"
                        >
                          In addition to business information and tax-year end
                          month, the following information is required to file
                          Form 8849 if you&apos;re claiming credits for sold
                          vehicles:
                          <ul>
                            <li>Originally filed tax period</li>
                            <li>First used month</li>
                            <li>VIN</li>
                            <li>Taxable gross weight</li>
                            <li>
                              Buyer information such as name, vehicle sold date,
                              and address
                            </li>
                          </ul>
                        </Typography>
                      </Box>
                    </Paper>
                  </Grid>
                  <Grid size={12}>
                    <Paper
                      variant="outlined"
                      sx={{ p: 2 }}
                      itemScope
                      itemProp="mainEntity"
                      itemType="https://schema.org/Question"
                    >
                      <Typography
                        variant="h2"
                        sx={{
                          fontWeight: 600,
                          color: '#36324a',
                          fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                          mb: 1,
                        }}
                        itemProp="name"
                      >
                        What information is required if I&apos;m claiming
                        credits for destroyed vehicles?
                      </Typography>
                      <Box
                        itemScope
                        itemProp="acceptedAnswer"
                        itemType="https://schema.org/Answer"
                      >
                        <Typography
                          variant="body1"
                          component="div"
                          itemProp="text"
                        >
                          In addition to business information and tax-year end
                          month, the following information is required to file
                          Form 8849 if you&apos;re claiming credits for
                          destroyed vehicles:
                          <ul>
                            <li>Originally filed tax period</li>
                            <li>First used month</li>
                            <li>VIN</li>
                            <li>Taxable gross weight</li>
                            <li>Vehicle destroyed date</li>
                          </ul>
                        </Typography>
                      </Box>
                    </Paper>
                  </Grid>
                  <Grid size={12}>
                    <Paper
                      variant="outlined"
                      sx={{ p: 2 }}
                      itemScope
                      itemProp="mainEntity"
                      itemType="https://schema.org/Question"
                    >
                      <Typography
                        variant="h2"
                        sx={{
                          fontWeight: 600,
                          color: '#36324a',
                          fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                          mb: 1,
                        }}
                        itemProp="name"
                      >
                        What information is required if I&apos;m claiming
                        credits for stolen vehicles?
                      </Typography>
                      <Box
                        itemScope
                        itemProp="acceptedAnswer"
                        itemType="https://schema.org/Answer"
                      >
                        <Typography
                          variant="body1"
                          component="div"
                          itemProp="text"
                        >
                          In addition to business information and tax-year end
                          month, the following information is required to file
                          Form 8849 if you&apos;re claiming credits for stolen
                          vehicles:
                          <ul>
                            <li>Originally filed tax period</li>
                            <li>First used month</li>
                            <li>VIN</li>
                            <li>Taxable gross weight</li>
                            <li>Vehicle stolen date</li>
                          </ul>
                        </Typography>
                      </Box>
                    </Paper>
                  </Grid>
                  <Grid size={12}>
                    <Paper
                      variant="outlined"
                      sx={{ p: 2 }}
                      itemScope
                      itemProp="mainEntity"
                      itemType="https://schema.org/Question"
                    >
                      <Typography
                        variant="h2"
                        sx={{
                          fontWeight: 600,
                          color: '#36324a',
                          fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                          mb: 1,
                        }}
                        itemProp="name"
                      >
                        What information is required if I&apos;m claiming
                        credits for low-mileage vehicles?
                      </Typography>
                      <Box
                        itemScope
                        itemProp="acceptedAnswer"
                        itemType="https://schema.org/Answer"
                      >
                        <Typography
                          variant="body1"
                          component="div"
                          itemProp="text"
                        >
                          In addition to business information and tax-year end
                          month, the following information is required to file
                          Form 8849 if you&apos;re claiming credits for
                          low-mileage vehicles:
                          <ul>
                            <li>Originally filed tax period</li>
                            <li>First used month</li>
                            <li>VIN</li>
                            <li>Taxable gross weight</li>
                          </ul>
                        </Typography>
                      </Box>
                    </Paper>
                  </Grid>
                  <Grid size={12}>
                    <Paper
                      variant="outlined"
                      sx={{ p: 2 }}
                      itemScope
                      itemProp="mainEntity"
                      itemType="https://schema.org/Question"
                    >
                      <Typography
                        variant="h2"
                        sx={{
                          fontWeight: 600,
                          color: '#36324a',
                          fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                          mb: 1,
                        }}
                        itemProp="name"
                      >
                        What information is required if I&apos;m claiming
                        credits for overpaid taxes?
                      </Typography>
                      <Box
                        itemScope
                        itemProp="acceptedAnswer"
                        itemType="https://schema.org/Answer"
                      >
                        <Typography
                          variant="body1"
                          component="div"
                          itemProp="text"
                        >
                          In addition to business information and tax-year end
                          month, the following information is required to file
                          <Link
                            href="/excise-tax/efile-irs-form-8849-schedule-6-online/"
                            sx={{ color: '#0202ff' }}
                          >
                            {' '}
                            IRS Form 8849
                          </Link>{' '}
                          if you&apos;re claiming credits for overpaid taxes:
                          <ul id="form990">
                            <li>VIN</li>
                            <li>Tax payment date</li>
                            <li>Claim amount</li>
                          </ul>
                        </Typography>
                      </Box>
                    </Paper>
                  </Grid>
                </Grid>
              </TabPanel>
            </Box>
          </Stack>
        </Container>
      </Grid>
      <Box
        sx={{
          backgroundColor: '#1da94a',
          py: { lg: 8, md: 8, sm: 4, xs: 4 },
          mx: '0 !important',
          width: '100% !important',
          mb: 0,
          p: 2,
          textAlign: 'center',
        }}
        m={2}
        mt={0}
        className="curve-bg"
      >
        <Typography
          variant="h2"
          color="white"
          sx={{
            fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
            fontWeight: 600,
            mb: 3,
          }}
        >
          Ready to simplify your complex tax filing process?
        </Typography>

        <Typography
          variant="h3"
          sx={{
            fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
            fontWeight: 400,
            color: '#f3f3f3',
            mb: 3,
          }}
        >
          Choose TaxZerone and file IRS tax forms online in easy steps.
        </Typography>
        <Box component="div" sx={{ margin: 'auto' }}>
          <Button
            variant="contained"
            sx={{
              mt: { xs: 0, sm: 4 },
              mb: { xs: 0, md: 0 },
              color: '#444',
              transition: 'all 0.3s ease 0s',
              '&:hover, &active': {
                backgroundColor: '#213e99 !important',
                color: '#fff',
                transform: 'scale(1.1)',
              },
            }}
            className="btn-secondary-white"
            href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=faqs`}
          >
            E-file Now
          </Button>
        </Box>
      </Box>
    </AppLayout>
  );
};

export default FAQs;
